import React from "react";
import Layout from "../Layout/Layout";
import {
  customDataTableStyles,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../Helper/Constants";
import DataTable from "react-data-table-component-with-filter";
import GetSvgIcon from "../../images/svglist";
import { Tooltip } from "react-tooltip";

const CharteredRateList = ({ handleAction, charteredRateList }) => {
  const columns = [
    {
      name: "Customer Name",
      selector: (row) => row.custName,
      sortable: true,
      filterable: true,
    },
    {
      name: "Account Code",
      selector: (row) => row.custAcctCode,
      sortable: true,
      filterable: true,
    },
    {
      name: "Weight",
      selector: (row) => row?.pricePerWeight,
      sortable: true,
      filterable: true,
    },

    {
      name: "Pieces",
      selector: (row) => row.pricePerPiece,
      sortable: true,
      filterable: true,
    },
    {
      name: "Manpower",
      selector: (row) => row.manpowerPrice,
      sortable: true,
      filterable: true,
    },
    {
      name: "Tailgate",
      selector: (row) => row.tailgatePrice,
      sortable: true,
      filterable: true,
    },
    {
      name: "",
      cell: (row) => (
        <>
          <div
            data-tooltip-id={"edit-" + row?.custId}
            onClick={() => handleAction(row, "EDIT Rate")}
          >
            {GetSvgIcon("EditPencil")}
          </div>
          <Tooltip id={"edit-" + row?.rateId} content={"Edit"} place="left" />
        </>
      ),
      allowOverflow: true,
      button: true,
      width: "30px",
    },
  ];

  return (
    <div className="col-md-12 customized-data-table position-relative">
      <DataTable
        columns={columns}
        data={charteredRateList}
        pagination
        striped
        highlightOnHover
        paginationRowsPerPageOptions={defaultRowsPerPageOptions}
        paginationPerPage={defaultPageLimit}
        customStyles={customDataTableStyles}
      />
    </div>
  );
};

export default CharteredRateList;
